import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GetLoginDetails, Result } from "application/types/GetLoginDetails";
import api from "application/utilities/axiosIntance";


interface LayoutState {
    data: Result | null;
    isLoading: boolean;
    error: string | null;
}

const initialState: LayoutState = {
    data: null,
    isLoading: false,
    error: null,
}

export const fetchLayoutData = createAsyncThunk(
    'layout/fetchLayoutData',
    async (regionCode: string, { rejectWithValue }) => {
        try {
            const response = await api.get<GetLoginDetails>('/Login/GetLoginPageDetails?regionCode=' + regionCode);
            return response.data.result;
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLayoutData.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(fetchLayoutData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(fetchLayoutData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload as string;
            });
    },
});

export default layoutSlice.reducer;